import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";

// Проста кнопка-перемикач теми. Іконки — інлайн SVG (сонце/місяць), щоб не
// залежати від спрайту iconBG, чиї вільні індекси невідомі.
const ThemeToggle = () => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className="btn btn1 btnIcon borderNone"
            aria-label={isDark ? "Увімкнути світлу тему" : "Увімкнути темну тему"}
            aria-pressed={isDark}
        >
            {/* span потрібен, щоб отримати z-index:2 з правила ".btn span"
                (GlobalStyles.js) — інакше іконка тоне під синім hover-оверлеєм
                кнопки, як і будь-який прямий не-span нащадок .btn. */}
            <span>
                {/* Іконка показує тему, НА ЯКУ перемкне клік (не поточну):
                    у світлій темі показуємо місяць (клік → темна тема), у
                    темній — сонце (клік → світла тема). Колір іконки й далі
                    залежить від активної теми (як і в сусідніх іконок
                    хедера), лише саме зображення (сонце/місяць) поміняли
                    місцями. */}
                {isDark ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="12" cy="12" r="4.5" fill="#F2F1E8" />
                        <g stroke="#F2F1E8" strokeWidth="1.6" strokeLinecap="round">
                            <line x1="12" y1="1.5" x2="12" y2="4" />
                            <line x1="12" y1="20" x2="12" y2="22.5" />
                            <line x1="1.5" y1="12" x2="4" y2="12" />
                            <line x1="20" y1="12" x2="22.5" y2="12" />
                            <line x1="4.2" y1="4.2" x2="6" y2="6" />
                            <line x1="18" y1="18" x2="19.8" y2="19.8" />
                            <line x1="4.2" y1="19.8" x2="6" y2="18" />
                            <line x1="18" y1="6" x2="19.8" y2="4.2" />
                        </g>
                    </svg>
                ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path
                            d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36A5.4 5.4 0 0 1 12 3z"
                            fill="#363738"
                        />
                    </svg>
                )}
            </span>
        </button>
    );
};

export default ThemeToggle;
